import { render, staticRenderFns } from "./router-popup.vue?vue&type=template&id=0b1b9601"
import script from "./router-popup.vue?vue&type=script&lang=js"
export * from "./router-popup.vue?vue&type=script&lang=js"
import style0 from "./router-popup.vue?vue&type=style&index=0&id=0b1b9601&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports